"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleHistoryReducer = exports.setVehicleInfoFaultFiltersAction = exports.setAvailableCustomTags = exports.dispatchNeedsAvailableTags = exports.applyCustomTagsChangesError = exports.applyCustomTagsChangesSuccess = exports.applyCustomTagsChanges = exports.setCustomTagsEditMode = exports.dispatchRequestVehicleData = exports.dispatchSelectDateRangeAction = exports.dispatchNeedsDataAction = exports.dispatchVinChangedAction = exports.VEHICLE_INFO_SET_SEVERITY_FILTERS = exports.VEHICLE_INFO_ERROR_VEHICLE_DATA = exports.VEHICLE_INFO_RECEIVE_VEHICLE_DATA = exports.VEHICLE_INFO_REQUEST_VEHICLE_DATA = exports.VEHICLE_INFO_SET_AVAILABLE_TAGS = exports.VEHICLE_INFO_NEEDS_AVAILABLE_TAGS = exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_ERROR = exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_SUCCESS = exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES = exports.VEHICLE_INFO_SET_CUSTOM_TAGS_EDIT_MODE = exports.VEHICLE_INFO_SELECT_DATE_RANGE = exports.VEHICLE_INFO_GOT_ERROR_ACTION = exports.VEHICLE_INFO_GOT_DATA_ACTION = exports.VEHICLE_INFO_NEEDS_DATA_ACTION = exports.VEHICLE_INFO_VIN_CHANGED_ACTION = void 0;
var vehicleInfo_model_1 = require("../models/vehicleInfo.model");
// Actions
exports.VEHICLE_INFO_VIN_CHANGED_ACTION = 'VEHICLE_INFO_VIN_CHANGED_ACTION';
exports.VEHICLE_INFO_NEEDS_DATA_ACTION = 'VEHICLE_INFO_NEEDS_DATA_ACTION';
exports.VEHICLE_INFO_GOT_DATA_ACTION = 'VEHICLE_INFO_GOT_DATA_ACTION';
exports.VEHICLE_INFO_GOT_ERROR_ACTION = 'VEHICLE_INFO_GOT_ERROR_ACTION';
exports.VEHICLE_INFO_SELECT_DATE_RANGE = 'VEHICLE_INFO_SELECT_DATE_RANGE';
exports.VEHICLE_INFO_SET_CUSTOM_TAGS_EDIT_MODE = 'VEHICLE_INFO_SET_CUSTOM_TAGS_EDIT_MODE';
exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES = 'VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES';
exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_SUCCESS = 'VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_SUCCESS';
exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_ERROR = 'VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_ERROR';
exports.VEHICLE_INFO_NEEDS_AVAILABLE_TAGS = 'VEHICLE_INFO_NEEDS_AVAILABLE_TAGS';
exports.VEHICLE_INFO_SET_AVAILABLE_TAGS = 'VEHICLE_INFO_SET_AVAILABLE_TAGS';
exports.VEHICLE_INFO_REQUEST_VEHICLE_DATA = 'VEHICLES_INFO_REQUEST_VEHICLE_DATA';
exports.VEHICLE_INFO_RECEIVE_VEHICLE_DATA = 'VEHICLES_INFO_RECEIVE_VEHICLE_DATA';
exports.VEHICLE_INFO_ERROR_VEHICLE_DATA = 'VEHICLES_INFO_ERROR_VEHICLE_DATA';
exports.VEHICLE_INFO_SET_SEVERITY_FILTERS = 'VEHICLE_INFO_SET_SEVERITY_FILTERS';
// Action Dispatchers
// TODO: this triggers an action to get flags. Should we change the name to make it more reusable? I'm using it to get fault flags for a specific fault on the event diagnosis page.
var dispatchVinChangedAction = function (vin) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_VIN_CHANGED_ACTION,
    payload: vin,
}); }; };
exports.dispatchVinChangedAction = dispatchVinChangedAction;
/** Dispatch that the VehicleInfo view needs to load data now that it is loaded */
var dispatchNeedsDataAction = function (vin) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_NEEDS_DATA_ACTION,
    payload: vin,
}); }; };
exports.dispatchNeedsDataAction = dispatchNeedsDataAction;
/**
 * dispatch VEHICLE_INFO_SELECT_DATE_RANGE
 */
var dispatchSelectDateRangeAction = function (dateRange) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_SELECT_DATE_RANGE,
    payload: dateRange,
}); }; };
exports.dispatchSelectDateRangeAction = dispatchSelectDateRangeAction;
/**
 * dispatch VEHICLE_INFO_SELECT_DATE_RANGE
 */
var dispatchRequestVehicleData = function () { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_REQUEST_VEHICLE_DATA,
}); }; };
exports.dispatchRequestVehicleData = dispatchRequestVehicleData;
/**
 * dispatch VEHICLE_INFO_SET_CUSTOM_TAGS_EDIT_MODE
 */
var setCustomTagsEditMode = function (isEditingCustomTags) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_SET_CUSTOM_TAGS_EDIT_MODE,
    payload: { isEditingCustomTags: isEditingCustomTags },
}); }; };
exports.setCustomTagsEditMode = setCustomTagsEditMode;
/**
 * dispatch VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES
 */
var applyCustomTagsChanges = function (vin, customTags) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES,
    payload: { vin: vin, customTags: customTags },
}); }; };
exports.applyCustomTagsChanges = applyCustomTagsChanges;
/**
 * dispatch VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_SUCCESS
 */
var applyCustomTagsChangesSuccess = function (payload) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_SUCCESS,
    payload: __assign({}, payload),
}); }; };
exports.applyCustomTagsChangesSuccess = applyCustomTagsChangesSuccess;
/**
 * dispatch VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_ERROR
 */
var applyCustomTagsChangesError = function () { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_ERROR,
}); }; };
exports.applyCustomTagsChangesError = applyCustomTagsChangesError;
/**
 * dispatch VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_ERROR
 */
var dispatchNeedsAvailableTags = function () { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_NEEDS_AVAILABLE_TAGS,
}); }; };
exports.dispatchNeedsAvailableTags = dispatchNeedsAvailableTags;
/**
 * dispatch VEHICLE_INFO_SET_AVAILABLE_TAGS
 */
var setAvailableCustomTags = function (availableCustomTags) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_SET_AVAILABLE_TAGS,
    payload: { availableCustomTags: availableCustomTags },
}); }; };
exports.setAvailableCustomTags = setAvailableCustomTags;
var setVehicleInfoFaultFiltersAction = function (severityFilters) { return function (dispatch) { return dispatch({
    type: exports.VEHICLE_INFO_SET_SEVERITY_FILTERS,
    payload: { severityFilters: severityFilters },
}); }; };
exports.setVehicleInfoFaultFiltersAction = setVehicleInfoFaultFiltersAction;
// Reducer
// eslint-disable-next-line default-param-last
var vehicleHistoryReducer = function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = (0, vehicleInfo_model_1.defaultVehicleInfoStateFactory)(); }
    switch (action.type) {
        case exports.VEHICLE_INFO_VIN_CHANGED_ACTION:
            return __assign(__assign({}, state), { isLoadingCustomTagsChanges: false, isEditingCustomTags: false, currentVin: action.payload, isLoading: true });
        case exports.VEHICLE_INFO_NEEDS_DATA_ACTION:
            return __assign(__assign({}, state), { isLoading: true });
        case exports.VEHICLE_INFO_GOT_DATA_ACTION:
            return __assign(__assign({}, state), { isLoading: false, vehicleInfoes: __assign(__assign({}, state.vehicleInfoes), (_a = {}, _a[action.payload.vin] = action.payload.vehicleInfo, _a)) });
        case exports.VEHICLE_INFO_GOT_ERROR_ACTION:
            return __assign(__assign({}, state), { isLoading: false, vehicleInfoErrors: __assign(__assign({}, state.vehicleInfoErrors), (_b = {}, _b[action.payload.vin] = action.payload.error, _b)) });
        case exports.VEHICLE_INFO_SELECT_DATE_RANGE:
            return __assign(__assign({}, state), { dateRange: {
                    startDate: action.payload.startDate ? action.payload.startDate.toISOString() : null,
                    endDate: action.payload.endDate ? action.payload.endDate.toISOString() : null,
                } });
        case exports.VEHICLE_INFO_SET_CUSTOM_TAGS_EDIT_MODE:
            return __assign(__assign({}, state), { isEditingCustomTags: action.payload.isEditingCustomTags });
        case exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES:
            return __assign(__assign({}, state), { isLoadingCustomTagsChanges: true });
        case exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_SUCCESS:
            return __assign(__assign({}, state), { vehicleInfoes: __assign(__assign({}, state.vehicleInfoes), (_c = {}, _c[action.payload.vin] = __assign(__assign({}, state.vehicleInfoes[action.payload.vin]), { customTags: action.payload.customTags }), _c)), isEditingCustomTags: false, isLoadingCustomTagsChanges: false });
        case exports.VEHICLE_INFO_SET_SEVERITY_FILTERS:
            return __assign(__assign({}, state), { faultFilters: action.payload.severityFilters });
        case exports.VEHICLE_INFO_APPLY_CUSTOM_TAGS_CHANGES_ERROR:
            return __assign(__assign({}, state), { isLoadingCustomTagsChanges: false });
        case exports.VEHICLE_INFO_SET_AVAILABLE_TAGS:
            return __assign(__assign({}, state), { availableCustomTags: action.payload.availableCustomTags });
        case exports.VEHICLE_INFO_RECEIVE_VEHICLE_DATA:
            return __assign(__assign({}, state), { vehicleData: action.payload });
        default: return state;
    }
};
exports.vehicleHistoryReducer = vehicleHistoryReducer;
exports.default = exports.vehicleHistoryReducer;
